import React from 'react'

import { Box } from '@mui/material'
import ProductionTrattamentiForm from './ProductionTrattamentiForm'
import { useSelector } from 'react-redux';




export const ProductionTrattamentiSlider = ({ cantine, setCantine }) => {
    const singleData = useSelector((state) => state.produzioneTrattamenti.singleProduzioneTrattamenti);
   
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra una trattamento</h2>
            </Box>
            <ProductionTrattamentiForm
                cantine={cantine} singleData={singleData} setCantine={setCantine}/>
        </Box>
    )

}
